export default "__VITE_ASSET__u1E1oKPy__"